import React from 'react';
import styled from 'styled-components';

const Divider = styled.hr`
  margin: ${p => p.margin || 'auto'};
  background: ${p => p.background || p.theme.palette.grey.eight};
  opacity: ${p => p.opacity || '0.2'};
  padding: ${p => p.padding || '0'};
  width: ${p => p.width || '100%'};
  margin-top: ${p => p.marginTop};
  margin-bottom: ${p => p.marginBottom};
`;

const Seperator = props => {
  return <Divider {...props} />;
};

export default Seperator;
